'use client';

// react
import React from 'react';

// styled-components
import { ThemeProvider as SCThemeProvider } from 'styled-components';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme as muiTheme } from '@/theme/mui';

// theme
import { theme as scTheme } from '@/theme';

/**
 * ThemeProvider provides a theme to all components within the provider.
 * `CssBaseline` paints `palette.background.default` on the document body.
 */
export const ThemeProvider = ({ children }: ThemeProviderProps) => (
  <MuiThemeProvider theme={muiTheme}>
    <CssBaseline />
    <SCThemeProvider theme={scTheme}>{children}</SCThemeProvider>
  </MuiThemeProvider>
);

interface ThemeProviderProps {
  children?: React.ReactNode;
}
ThemeProvider.componentName = 'ThemeProvider';
